module.exports = __webpack_public_path__ + "static/img/colektia.6d5b729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colektia.png
// module id = kOCa
// module chunks = 11